import { Link } from 'react-router-dom';
import { SITE } from '../data/content/site';

/**
 * StaticFooter Component
 *
 * Reusable footer for logged-out pages (HomePage, WaitlistPage)
 * Contains privacy links and copyright - part of page, not app layout
 *
 * Link order follows Frank's IA feedback (#803):
 * About | For Leaders | FAQ | Contact | Privacy | Terms
 * (grouped by purpose: product info → support → legal)
 *
 * "For Leaders" → the leaders argument page (/leaders, LeaderWhyPage #3125),
 * which itself hands off to the Getting Started guide (#2836). Argument before
 * instructions — the how-to is a click deeper, not the entry point (#3222).
 */
export default function StaticFooter() {
  const handleLinkClick = () => {
    // Scroll to top when navigating to legal/info pages
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="w-full flex flex-col items-center gap-6 py-6 pb-12 px-4">
      {/* Footer Links - ordered by purpose (#803) */}
      <nav className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-xs">
        {/* Product Info */}
        <Link
          to="/about"
          onClick={handleLinkClick}
          className="text-text-secondary hover:text-accent transition-colors min-h-11 flex items-center"
        >
          About
        </Link>
        <Link
          to="/leaders"
          onClick={handleLinkClick}
          className="text-text-secondary hover:text-accent transition-colors min-h-11 flex items-center"
        >
          For Leaders
        </Link>
        {/* Support */}
        <Link
          to="/faq"
          onClick={handleLinkClick}
          className="text-text-secondary hover:text-accent transition-colors min-h-11 flex items-center"
        >
          FAQ
        </Link>
        <Link
          to="/contact"
          onClick={handleLinkClick}
          className="text-text-secondary hover:text-accent transition-colors min-h-11 flex items-center"
        >
          Contact
        </Link>
        {/* Legal */}
        <Link
          to="/privacy"
          onClick={handleLinkClick}
          className="text-text-secondary hover:text-accent transition-colors min-h-11 flex items-center"
        >
          Privacy
        </Link>
        <Link
          to="/terms"
          onClick={handleLinkClick}
          className="text-text-secondary hover:text-accent transition-colors min-h-11 flex items-center"
        >
          Terms
        </Link>
      </nav>

      {/* Concrete trust claims (#3123, owner decision 2026-08-23). Here rather
          than on the front door alone so every public page carries them. Each
          claim is pinned to the wording that backs it — privacy.ts for ads and
          selling, terms.ts for passwords — by StaticFooter.test.tsx. See
          data/content/site.ts, which also keeps the string inside
          check-voice.mjs's roots. */}
      <p className="text-xs text-text-muted">{SITE.footerTrust}</p>

      {/* Copyright - below links to avoid iOS URL bar overlap */}
      <p className="text-xs text-text-muted">
        © {currentYear} ORO, LLC. All rights reserved.
      </p>
    </footer>
  );
}